import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AppDetailPage from './pages/AppDetailPage';
import ContactPage from './pages/ContactPage';
import DocumentationPage from './pages/DocumentationPage';
import DemoPage from './pages/DemoPage';
import TermsPage from './pages/TermsPage';
import ScrollToTop from './components/ScrollToTop';
import TrackingInitializer from './components/TrackingInitializer';

function App() {
  return (
    <BrowserRouter>
      <TrackingInitializer />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/apps/:appId" element={<AppDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/documentation" element={<DocumentationPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/conditions-generales" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

